export const contractAddresses = {
  goerli: {
    anonMoodIndex: "0x0137478F6E112410C5aB917A05805DB4923440E1",
  },
};
